/* @flow */
import React from 'react';
import ReactDOM from 'react-dom';
import pickGlobalElementProps from 'utils/pickInputElementProps';

import DOM from 'lib/DOM';

const stack = [];

class ScrollContext extends React.Component {
  componentWillMount() {
    const context = stack[stack.length - 1];
    if (context) {
      context.fix();
      window.scrollTo(0, 0);
    }
  }

  componentDidMount() {
    stack.push(this);
  }

  componentWillUnmount() {
    const index = stack.indexOf(this);
    if (index >= 0) {
      stack.splice(index, 1);

      const context = stack[stack.length - 1];
      if (context) {
        context.restore();
      }
    }
  }

  _pos = null;

  fix = () => {
    const pos = DOM.getScrollPosition();

    const node = ReactDOM.findDOMNode(this);
    node.style.cssText =
      'position: fixed;' +
      `left: -${pos.left}px;` +
      `top: -${pos.top}px;`;

    this._pos = pos;
  };

  restore = () => {
    const node = ReactDOM.findDOMNode(this);
    node.style.cssText = '';
    if (this._pos) {
      window.scrollTo(this._pos.left, this._pos.top);
      this._pos = null;
    }
  };

  render() {
    const props = pickGlobalElementProps(this.props);
    return <div {...props}>{this.props.children}</div>;
  }
}

const MockScrollContext = (props: Object) => <div {...props} />;

export default (typeof window === 'undefined') ? MockScrollContext : ScrollContext;



// WEBPACK FOOTER //
// ./src/components/ScrollContext.jsx